import { AnyAction, createReducer } from '@reduxjs/toolkit';

import { MapManagementStoreState } from '@Types';
import {
	getThemeListResolved,
	regenerateAssetTiles,
	regenerateAssetTilesResolved,
	regenerateInspectionTiles,
	regenerateInspectionTilesResolved,
	regenerateSensorTiles,
	regenerateSensorTilesResolved,
} from '@Actions/mapManagement';

export const initialState: MapManagementStoreState = {
	themeList: [],
	tileData: {
		isAssetGenerationInProgress: false,
		isSensorGenerationInProgress: false,
		isInspectionGenerationInProgress: false,
	},
};

interface MapManagementReducer {
	[x: string]: (
		state: MapManagementStoreState,
		action: AnyAction,
	) => MapManagementStoreState | undefined;
}

const reducer: MapManagementReducer = {
	[getThemeListResolved.toString()]: (state, action) => {
		return {
			...state,
			themeList: action.payload,
		};
	},
	[regenerateAssetTiles.toString()]: state => {
		return {
			...state,
			tileData: {
				...state.tileData,
				isAssetGenerationInProgress: true,
			},
		};
	},
	[regenerateAssetTilesResolved.toString()]: state => {
		return {
			...state,
			tileData: {
				...state.tileData,
				isAssetGenerationInProgress: false,
			},
		};
	},
	[regenerateSensorTiles.toString()]: state => {
		return {
			...state,
			tileData: {
				...state.tileData,
				isSensorGenerationInProgress: true,
			},
		};
	},
	[regenerateSensorTilesResolved.toString()]: state => {
		return {
			...state,
			tileData: {
				...state.tileData,
				isSensorGenerationInProgress: false,
			},
		};
	},
	[regenerateInspectionTiles.toString()]: state => {
		return {
			...state,
			tileData: {
				...state.tileData,
				isInspectionGenerationInProgress: true,
			},
		};
	},
	[regenerateInspectionTilesResolved.toString()]: state => {
		return {
			...state,
			tileData: {
				...state.tileData,
				isInspectionGenerationInProgress: false,
			},
		};
	},
};

export default createReducer(initialState, reducer);
